export function asNumber(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function parseQuarter(label: string): { year: number; quarter: number } | null {
  const match = label.match(/^Q([1-4])\s+(\d{4})$/);
  if (!match) return null;
  return { year: Number(match[2]), quarter: Number(match[1]) };
}

export function latest<T>(arr: T[]): T | null {
  return arr.length > 0 ? arr[arr.length - 1] : null;
}

export function previous<T>(arr: T[]): T | null {
  return arr.length >= 2 ? arr[arr.length - 2] : null;
}

export function pctChange(current: number, prevVal: number | null): number | null {
  if (prevVal === null || prevVal === 0) return null;
  return ((current - prevVal) / prevVal) * 100;
}

export function formatYoYSublabel(yoy: number | null): string {
  if (yoy === null) return '— YoY';
  if (yoy === 0) return '0.00% YoY';
  const arrow = yoy > 0 ? '↑' : '↓';
  return `${arrow}${Math.abs(yoy).toFixed(2)}% YoY`;
}

export function calcYtdYoYChange<T>(
  series: T[],
  currentQuarter: string,
  readQuarter: (point: T) => string,
  readValue: (point: T) => number
): number | null {
  const currentMeta = parseQuarter(currentQuarter);
  if (!currentMeta) return null;

  const ytd = series
    .filter((point) => {
      const meta = parseQuarter(readQuarter(point));
      return meta?.year === currentMeta.year && meta.quarter <= currentMeta.quarter;
    })
    .reduce((sum, point) => sum + readValue(point), 0);

  const priorYearYtd = series
    .filter((point) => {
      const meta = parseQuarter(readQuarter(point));
      return meta?.year === currentMeta.year - 1 && meta.quarter <= currentMeta.quarter;
    })
    .reduce((sum, point) => sum + readValue(point), 0);

  return pctChange(ytd, priorYearYtd || null);
}
